import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
    active: {
        backgroundColor: theme.palette.action.selected,
    },
    icon: {
        marginLeft: 8
    }
}));
